import React from "react";
import Loader from "@amzn/meridian/loader";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
var LoadingComponent = function(param) {
    var isLoading = param.isLoading;
    if (!isLoading) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(Column, {
        heights: "100%",
        alignmentVertical: "center"
    }, /*#__PURE__*/ React.createElement(Row, {
        alignmentHorizontal: "center"
    }, /*#__PURE__*/ React.createElement(Loader, {
        size: "medium"
    })));
};
export default LoadingComponent;

//# sourceMappingURL=LoadingComponent.js.map